module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_BlackMatted.5abece5c.jpg";